import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Heading } from '../../../_lib/components/Heading/Heading';
import { PostsEditor } from '../../../_lib/components/Posts';
import { useFocusOnRefreshWithTabIndex, useRefreshBlock } from '../../../_lib/BlockFetcher';
import IForm from '../../../types/IForm';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type CommentsStandardEditorProps = {
  subHeadingsHierarchy: number;
  createForm: IForm;
};

export function CommentsMainEditor({ subHeadingsHierarchy, createForm }: CommentsStandardEditorProps) {
  // some forms don't open editor, so we need a separate state to check
  const [toggleEditor, setToggleEditor] = useState<boolean>(false);
  const { refreshCount, refreshProps } = useRefreshBlock();
  const focusRef = useFocusOnRefreshWithTabIndex<HTMLHeadingElement>(refreshCount);
  const { hash } = useLocation();
  const { t } = useSonTranslation('CommentsBlock');

  const commentsMainEditor = 'comments-main-editor';

  useEffect(() => {
    if (!hash.includes(commentsMainEditor)) {
      setToggleEditor(false);
    }
  }, [hash]);

  useEffect(() => {
    setToggleEditor(false);
  }, [refreshCount]);

  return (
    <>
      <Heading
        hierarchy={subHeadingsHierarchy}
        className="posts__heading"
        ref={refreshProps === undefined ? focusRef : null}
      >
        {t('default.heading.writeComment')}
      </Heading>
      {!toggleEditor && (
        <a
          className="posts__fake-textarea"
          href={`#${commentsMainEditor}`}
          onClick={() => setToggleEditor(!toggleEditor)}
        >
          {t('default.textareaPlaceholder')}
        </a>
      )}
      <div className="posts__skip-to-editor" id={commentsMainEditor}>
        <div className="posts__skip-to-editor-content">
          {toggleEditor && <PostsEditor form={createForm} type="comment" autoFocus />}
        </div>
      </div>
    </>
  );
}
